export function getVariantFromId(_id, variants) {
    const last3 = parseInt(_id.slice(-3), 16);
    const modulo = last3 % variants.length;
    return variants[modulo] || variants[0];
}
